import type { ComplaintSummary } from '../types/complaint.types';

/** How a closed complaint ended, in words; null while it is open. */
export function complaintOutcome(complaint: ComplaintSummary): string | null {
  if (complaint.status === 'rejected') return 'Rejected';
  if (complaint.status !== 'resolved') return null;
  if (complaint.resolution === 'refund') return 'Resolved with a refund';
  if (complaint.resolution === 'no_refund') return 'Resolved, no refund';
  return 'Resolved';
}
